import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'generic-icon',
    templateUrl: './generic-icon.component.html',
    styleUrls: ['./generic-icon.component.scss'],
    standalone: false
})
export class GenericIconComponent implements OnInit {

  constructor() { }

  @Input()type:string='google';
  @Input()iconName:string;
  @Input()color:string;

  ngOnInit(): void {
      
  }

}
